(function () {
  const inputTarget = '.scores-input input';

  const outingsScores = function () {

    const nextTeam = (elem) => {
      const nextTeam = $(elem).closest('.card').next('.card');
      if (nextTeam.length > 0) return nextTeam;
    };

    const focusNextInput = (elem) => {
      let nextTd = $(elem).closest('.scores-input').next();

      if (nextTd.hasClass('in') || nextTd.hasClass('out') || nextTd.hasClass('total'))
        nextTd = nextTd.next();
      if (nextTd.hasClass('in') || nextTd.hasClass('out') || nextTd.hasClass('total'))
        nextTd = nextTd.next();

      if (nextTd.length === 0)
        nextTd = $(elem).closest('.scores-input')
                        .parent()
                        .next('tr')
                        .find('.scores-input')
                        .first();

      if (nextTd.length === 0 && nextTeam(elem))
        nextTd = nextTeam(elem).find('.scores-input').first();

      if (nextTd.length === 0) return $('input[type="submit"]').trigger('focus');

      nextTd.find('input').trigger('focus');
    };

    const calculateParDiff = (elem) => {
      const parDiffElem = $(elem).closest('.scores-input').find('[data-par-diff]');
      const score = parseInt($(elem).val());
      const holePar = parseInt(parDiffElem.data('hole-par'));

      let parDiff = score - holePar;
      if (parDiff > 2) parDiff = 2;
      else if (parDiff < -2) parDiff = -2;

      parDiffElem.attr('data-par-diff', parDiff === 0 ? '' : parDiff);
    }

    const updateTotals = () => {
      $('.competitor-line').each(function(){
        let totalSum = 0;
        let inSum = 0;
        let outSum = 0;

        const inputs = $(this).find('input').toArray();
        for (let i = 0; i < inputs.length; i++) {
          const elem = inputs[i];
          if (i < 9)
            outSum += parseInt($(elem).val()) || 0;
          else
            inSum += parseInt($(elem).val()) || 0;
        }
        totalSum = inSum + outSum;

        $(this).find('.in').text(inSum);
        $(this).find('.out').text(outSum);
        $(this).find('.total').text(totalSum);
      });
    };

    const bindInput = () => {
      $(document).on('keyup', inputTarget, function(e){
        const integerValue = parseInt($(this).val());

        if (!integerValue || integerValue === 0) $(this).val('');

        if (integerValue >= 20) {
          $(this).val($(this).val()[1]);
        }

        calculateParDiff(this);

        if (integerValue > 1) {
          focusNextInput(this);
        }

        updateTotals();
      });

      $(document).on('focus', inputTarget, function() {
        $(this).trigger('select');
      });
    };

    const bindOpenInput = () => {
      $('.scores-input').on('click', function() {
        $(this).find('input').trigger('focus');
      });
    };

    const isScoresPage = () => $('body').hasClass('controller-outings-scores');

    const setScrollRestoration = (value) => {
      if ('scrollRestoration' in history) history.scrollRestoration = value;
    };

    const scrollToScoreEntry = () => {
      if (!$('#outing-score-entry').length) return;
      window.scrollTo(0, 0);
    };

    const focusFirstScoreInput = () => {
      const input = $('#outing-score-entry td.scores-input input').get(0);
      if (!input) return;

      input.focus({ preventScroll: true });
      input.select();
    };

    const jumpToScoreEntry = () => {
      setScrollRestoration('manual');
      scrollToScoreEntry();
      focusFirstScoreInput();
      window.requestAnimationFrame(scrollToScoreEntry);
    };

    $(document).on('turbolinks:load', () => {
      if (!isScoresPage()) {
        setScrollRestoration('auto');
        return;
      }

      bindInput();
      bindOpenInput();
      updateTotals();
      jumpToScoreEntry();
    });

    window.addEventListener('load', scrollToScoreEntry);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) return;
      scrollToScoreEntry();
    });
  };

  if (typeof window !== "undefined") {
    window.outingsScores = outingsScores();
  }
})();
